import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

export class ExportedDatabaseNotificationStrategy extends DefaultNotificationStrategy<NotificationType.ExportedDatabase> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.ExportedDatabase>, authorNick: string): IBrowserNotification {
    const title = `${authorNick}, your database export has finished!`
    const body = 'Your requested database export has finished. You can find your file in browser downloads folder'
    const sound = getNotificationSoundUrl('new-notification.wav')
    const {fileString, mimeType, fileName} = notification.payload
    const a = document.createElement('a')
    a.href = `data:${mimeType};base64,${fileString}`
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    return {
      sound,
      title,
      body,
    }
  }

}
